<template>
  <div class="retinueMorePage">
    <div class="list-moreContent" id="list-moreContent">
      <van-list
        v-model="Moreloading"
        :finished="Morefinished"
        finished-text="没有更多了"
      >
        <van-checkbox-group v-model="result">
          <van-cell-group>
            <van-cell
              v-for="(item, index) in retinueMainList"
              clickable
              :key="item.id"
              :title="`${item.stageName+' (' + item.proportion +'%' +')'}`"
              @click="toggle(index, item)"
              class="item"
            >
              <van-checkbox
                :name="item.stageName"
                :disabled='item.isDefault'
                ref="checkboxes"
                slot="right-icon"
              />
            </van-cell>
          </van-cell-group>
        </van-checkbox-group>
      </van-list>
    </div>
    <div class="roleBtn clearfix">
      <a href="javascript:void(0);" class="fl" @click="closeRetinuePicker"
        >取消</a
      >
      <a href="javascript:void(0);" class="fl" @click="saveRetinue">确认</a>
    </div>
  </div>
</template>
<script>
/*eslint-disable*/
import newApi from "lodash";
export default {
  name: "moreSelectProportion",
  data() {
    return {
      total: "", //统计计算
      retinueMainList: [],
      retinueList: [], //项目进度列表
      result: [], //选择的项进度列表
      retinuedata: [], //选中的项目进度列表
      transmitList: [],
      morePage: 1,
      morePageSize: 20,
      Moreloading: false, //是否处于加载状态
      Morefinished: false, //是否已加载完所有数据
      clientType: "", //手机类型
    };
  },
  props: {
    staffIds: {
      type: Array,
      default: () => [],
    },
  },
  mounted() {
    this.getMoreTest();
  },
  methods: {
    toggle(index, item) {
      if(!item.isDefault){
        this.$refs.checkboxes[index].toggle();
        this.retinuedata.push(item);
        this.unique(this.retinuedata);
      }
    },

    getMoreTest() {
      let _this = this;

      _this.$api.project
        .configList(_this.morePage, _this.morePageSize, {
          status: true,
        })
        .then((res) => {
          //let retinuedata = []
          let name = []
          if (res.code == "1") {
            res.data.list.forEach(item =>{
              if(item.isDefault){
                //retinuedata.push(item)
                name.push(item.stageName)
              }
            })
            //_this.retinuedata = retinuedata
            _this.result = name
            _this.total = parseInt(res.data.total);
            _this.retinueList = res.data.list;
            _this.viewLists();
            // 加载状态结束
            this.Moreloading = false;

            _this.Morefinished = true;
            console.log("加载完成");
          } else {
            console.log(res.msg);
          }
        })
        .catch((err) => {
          this.Morefinished = true;
          console.log(err);
        });
    },
    viewLists() {
      let _this = this;

      _this.retinueMainList = _this.retinueMainList.concat(_this.retinueList);
      if (_this.retinueMainList.length == _this.total) {
        if (_this.staffIds[0]) {
          for (let i = 0; i < _this.staffIds.length; i++) {
            for (let j = 0; j < _this.retinueMainList.length; j++) {
              if (_this.staffIds[i] == _this.retinueMainList[j].id) {
                _this.result.push(_this.retinueMainList[j].stageName);
                _this.retinuedata.push(_this.retinueMainList[j]);
              }
            }
          }
        }
      }
    },
    closeRetinuePicker() {
      this.$emit("closeProportion", this.transmitList);
    },
    saveRetinue() {
      let _this = this;
      _this.getNewArr(this.retinuedata);
      _this.transmitList = _this.retinuedata;
      _this.$emit("moreSetProportion", _this.transmitList);
    },
    getNewArr(dataArray) {
      //数组去重
      let newArr = [];
      for (var i = 0; i < dataArray.length; i++) {
        var flag = true;
        for (var j = 0; j < newArr.length; j++) {
          if (dataArray[i].id == newArr[j].id) {
            flag = false;
            break;
          }
        }
        if (flag) {
          newArr.push(dataArray[i]);
        }
      }

      this.retinuedata = newArr;
    },
    unique(dataArray) {
      //数组去重
      let _this = this;
      let removeIndex = [];
      dataArray.forEach((item1, index1) => {
        const exist = dataArray.some(
          (item2, index2) => item1.id === item2.id && index1 !== index2
        );
        if (exist) {
          removeIndex.unshift(index1);
        }
      });
      newApi.each(removeIndex, (index) => {
        delete dataArray[index];
      });

      _this.retinuedata = _this.retinuedata.filter(function () {
        return true;
      });
    },
    reloadPage() {
      this.morePage = 0;
      this.retinueMainList = [];
      this.morePageSize = 50;
      this.Moreloading = false; //是否处于加载状态
      this.Morefinished = false; //是否已加载完所有数据

      this.getMoreTest();
    },
  },
  watch: {
    staffIds: {
      handler: function (valArray) {
        this.result = [];
        this.retinuedata = [];
        this.reloadPage();
      },
      deep: true,
    },
  },
};
</script>
<style lang="less" >
.retinueMorePage {
  width: 100%;
  height: 100%;
  background-color: #fff;

  .list-moreContent {
    height: calc(100% - 25px);
    overflow-y: scroll;
    .list-item {
      .item {
        height: 45px;
      }
    }
  }
  .roleBtn {
    position: fixed;
    width: 100%;
    font-size: 0.42667rem;
    text-align: center;
    color: #333;
    height: 45px;
    bottom: 0;
    z-index: 999;
    background-color: #fff;
    border-top: 1px solid #f6f6f6;
    a:first-child {
      color: rgb(235, 199, 155);
      border-right: 1px solid #f6f6f6;
    }
    a {
      display: inline-block;
      width: 50%;
      height: 100%;
      line-height: 45px;
      color: #07c160;
      font-size: 14px;
      box-sizing: border-box;
    }
  }
}
</style>